module.exports = __webpack_public_path__ + "img/cctv-traffic.02dcfae8.png";